// extracted by mini-css-extract-plugin
export var brand = "_bt-9";
export var compact = "_bt-6";
export var extraSmall = "_bt-7";
export var icon = "_bt-0";
export var large = "_bt-4";
export var light = "_bt-1";
export var medium = "_bt-5";
export var outline = "_bt-b";
export var primaryDark = "_bt-a";
export var primaryLight = "_bt-8";
export var primaryModern = "_bt-c";
export var success = "_bt-2";
export var successSolid = "_bt-3";